export enum enumData {
  id = 'id',
  criadoEm = 'criadoEm',
  dataCarregamento = 'dataCarregamento',
  dataEntrega = 'dataEntrega',
  idSkuEntregue = 'idSkuEntregue',
  quantidadeEntregue = 'quantidadeEntregue',
  unidadeMedida = 'unidadeMedida',
  novo = 'novo',
  skuDescricao = 'skuDescricao',
  centroOrigem = 'centroOrigem',
  centroDestino = 'centroDestino',
  centroOrigemDescricao = 'centroOrigemDescricao',
  centroDestinoDescricao = 'centroDestinoDescricao',
  depositoOrigem = 'depositoOrigem',
  depositoDestino = 'depositoDestino',
  centroOrigemDescricaoLabel = 'centroOrigemDescricaoLabel',
  centroDestinoDescricaoLabel = 'centroDestinoDescricaoLabel',
  step = 'step',
  paletizacao = 'paletizacao',
  quantidadeDePaletes = 'quantidadeDePaletes',
  contratoSap = 'contratoSap',
  grupoAmarracao = 'grupoAmarracao',
  origem = 'origem',
  saldo = 'saldo',
}
export interface Data {
  [enumData.id]: number;
  [enumData.criadoEm]: Date;
  [enumData.dataCarregamento]: Date;
  [enumData.dataEntrega]: Date;
  [enumData.idSkuEntregue]: number;
  [enumData.quantidadeEntregue]: number;
  [enumData.unidadeMedida]?: string;
  [enumData.novo]: boolean;
  [enumData.skuDescricao]?: string;
  [enumData.centroOrigem]: string;
  [enumData.centroDestino]: string;
  [enumData.centroOrigemDescricao]: string;
  [enumData.centroDestinoDescricao]: string;
  [enumData.depositoOrigem]: string;
  [enumData.depositoDestino]: string;
  [enumData.centroOrigemDescricaoLabel]?: string;
  [enumData.centroDestinoDescricaoLabel]?: string;
  [enumData.step]: number;
  [enumData.paletizacao]: number;
  [enumData.quantidadeDePaletes]: number;
  [enumData.contratoSap]: string;
  [enumData.grupoAmarracao]?: string;
  [enumData.origem]?: string;
  [enumData.saldo]?: number;
}

export interface LoadGroup {
  [key: string]: {
    name: string;
    total: number;
  }
}
